import AppBar from '@material-ui/core/AppBar'
import Tab from '@material-ui/core/Tab'
import Tabs from '@material-ui/core/Tabs'
import { useTheme } from '@material-ui/core/styles'
import { Redirect, useParams } from 'react-router-dom'

import { buildFeatureSet, canAccessTab, getCredentials } from '../../cache/auth'
import { TabPanel } from '../../helpers/TabPanel'
import { getTranslate } from '../../localization'
import { LocalizedLink } from '../../routes/localizedRoutes'
import accessManagementPagesRoleManagement from '../../staticRoleManagement/accessManagementRoleManagement'
import AccessManagement from '../AccessManagement'
import FeatureFlag from '../FeatureFlag'
import RoleManagementList from '../RoleManagementList'
import UserManagement from '../userManagement'
import useStyles from './styles/index.styles'

export default function AccessManagementTabs() {
  const classes = useStyles()
  const theme = useTheme()
  const { page } = useParams<{
    page: string
  }>()
  const tabsList = [
    {
      value: 'role-management',
      className: classes.tab,
      label: getTranslate('Role Management'),
      component: LocalizedLink,
      to: `/access-management/role-management`
    },
    {
      value: 'feature-flag',
      className: classes.tab,
      label: getTranslate('Feature Flag'),
      component: LocalizedLink,
      to: `/access-management/feature-flag`
    },
    {
      value: 'user-management',
      className: classes.tab,
      label: getTranslate('User Management'),
      component: LocalizedLink,
      to: `/access-management/user-management`
    },
    {
      value: 'bulk-access',
      className: classes.tab,
      label: getTranslate('Bulk Access'),
      component: LocalizedLink,
      to: `/access-management/bulk-access`
    }
  ]

  const credentials = getCredentials()
  const featureSet = buildFeatureSet(credentials)

  const routeConfig = accessManagementPagesRoleManagement.find(
    (item) => item.route === '/access-management/:page'
  )

  const visibleTabs = tabsList.filter((tab) =>
    canAccessTab(routeConfig, tab.value, featureSet)
  )

  if (!canAccessTab(routeConfig, page, featureSet)) {
    return <Redirect to="/403" />
  }

  return (
    <div className={classes.root}>
      <AppBar position="static" color="transparent">
        <Tabs
          value={page}
          indicatorColor="primary"
          textColor="primary"
          variant="fullWidth">
          {visibleTabs.map((item, index) => (
            <Tab
              key={index}
              value={item.value}
              className={item.className}
              label={item.label}
              component={item.component}
              to={item.to}
            />
          ))}
        </Tabs>
      </AppBar>
      <TabPanel
        value={page}
        index="role-management"
        dir={theme.direction}
        className={classes.tabPanel}>
        <RoleManagementList />
      </TabPanel>
      <TabPanel
        value={page}
        index="feature-flag"
        dir={theme.direction}
        className={classes.tabPanel}>
        <FeatureFlag />
      </TabPanel>
      <TabPanel
        value={page}
        index="user-management"
        dir={theme.direction}
        className={classes.tabPanel}>
        <UserManagement />
      </TabPanel>
      <TabPanel
        value={page}
        index="bulk-access"
        dir={theme.direction}
        className={classes.tabPanel}>
        <AccessManagement />
      </TabPanel>
    </div>
  )
}
